import { useState } from "react";

function useUncontrolled(_ref) {
  let {
    value,
    defaultValue,
    finalValue,
    onChange = () => {}
  } = _ref;
  const [uncontrolledValue, setUncontrolledValue] = useState(defaultValue !== void 0 ? defaultValue : finalValue);

  const handleUncontrolledChange = function (val) {
    setUncontrolledValue(val);

    for (var _len = arguments.length, payload = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      payload[_key - 1] = arguments[_key];
    }

    onChange == null ? void 0 : onChange(val, ...payload);
  };

  if (value !== void 0) {
    return [value, onChange, true];
  }

  return [uncontrolledValue, handleUncontrolledChange, false];
}

export { useUncontrolled };